import React from 'react'
import SimpleTableTable from '../../../../../Components/SimpleTableTable'

const RosterMissionsTableView = ({
  header,
  data,
  sortOn,
  filterOn,
  postRowRender,
  searchOn,
  footerRender,
  action,
  cypress_id,
  isNeedToShowGroupedMissions,
}) => {
  return (
    <SimpleTableTable
      header={header}
      data={data}
      filterOn={filterOn}
      sortOn={sortOn}
      postRowRender={postRowRender}
      searchOn={searchOn}
      footerRender={footerRender}
      showPages={false}
      action={action}
      cypress_id={cypress_id}
      isNeedToShowGroupedMissions={isNeedToShowGroupedMissions}
    />
  )
}

export default RosterMissionsTableView
